/**
 * Account Info section tabs: /accountCreate/:gId/:section renders one section
 * form per screen (mirrors the Building Info pattern, without groups — five
 * sections need no second level). Create mode (/accountCreate, no gId) keeps
 * the original accordion run and does not use this config.
 */
export interface AccountInfoSectionDef {
  slug: string
  label: string
  /** Activate-internal only — hidden from customers however their roles are set. */
  acAdminOnly?: boolean
}

export const ACCOUNT_INFO_SECTIONS: AccountInfoSectionDef[] = [
  { slug: 'accountInfo', label: 'Account Info' },
  { slug: 'branding', label: 'Branding' },
  { slug: 'preferences', label: 'Preferences' },
  { slug: 'analytics', label: 'Analytics', acAdminOnly: true },
  { slug: 'coi', label: 'COI Information' },
  { slug: 'tenantCompanies', label: 'Tenant Companies' },
]
